////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import React, {useState} from 'react';
import {Task} from "../dataModel/Task";
import TextInput from "@adsk/alloy-react-text-input";
import Theme from "@adsk/alloy-react-theme";
import {FlexColumn} from "../CommonStyledComponents";

const SettingsGeneral = ({task, onChange}: {
  task: Task | undefined,
  onChange?: (value: string, field: 'name' | 'description') => void
}) => {
  const [internalName, setInternalName] = useState(task?.Name ?? '');
  const [internalDescription, setInternalDescription] = useState(task?.Description ?? '');

  function sendUpdate(field: 'name' | 'description'): void {
    if (task == null) {
      return;
    }

    let value = '';
    switch (field) {
      case "name":
        task.Name = internalName;
        value = internalName;
        break;
      case "description":
        task.Description = internalDescription;
        value = internalDescription;
        break;
    }

    if (onChange) {
      onChange(value, field);
    }
  }

  return (
    <FlexColumn>
      <h2 style={Theme.typography.heading2}>Name</h2>
      <TextInput value={internalName}
                 placeholder={'Enter a task name...'}
                 onKeyDown={() => sendUpdate('name')}
                 onChange={v => setInternalName(v.target.value)}
                 onBlur={() => sendUpdate('name')}/>
      <h2 style={Theme.typography.heading2}>Description</h2>
      <TextInput value={internalDescription}
                 placeholder={'Enter a task description (optional)...'}
                 onKeyDown={() => sendUpdate('description')}
                 onChange={v => setInternalDescription(v.target.value)}
                 onBlur={() => sendUpdate('description')}/>
    </FlexColumn>
  );
};

export default SettingsGeneral;